/**
 * Main Boot Record
 * Модуль загружающий движок и игру. Должен иметь минимальный размер (<15Kb) для быстрой инициализации.
 */

import 'game/style/main.css';
import 'game/style/loader.css';
import Preloader from 'engine/js/ui/preloader';
import { Logger } from 'engine/js/utils/logger';

Logger.log('boot');

window.preloader = new Preloader('body');
window.preloader.show();

import(/* webpackChunkName: "loader" */ './loader').then(({ default: run }) => {
    Logger.log('loader load complete');
    run();
}).catch((err) => {
    if(err)
        Logger.error(err);
});
